"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = void 0;
const config = exports.config = {
  alwaysSearchOnInitialLoad: true,
  searchQuery: {
    disjunctiveFacets: ['design_language', 'component_library', 'backward_compat', 'availability'],
    facets: {
      // fields that can be used to filter
      design_language: {
        type: 'value',
        size: 100
      },
      component_library: {
        type: 'value',
        size: 100
      },
      backwards_compat: {
        type: 'value',
        size: 100
      },
      availability: {
        type: 'value',
        size: 100
      }
    },
    search_fields: {
      name: {
        weight: 2
      },
      see_also: {}
    },
    result_fields: {
      // fields that can be used for displaying results
      name: {
        raw: {}
      },
      url: {
        raw: {}
      },
      design_language: {
        raw: {}
      },
      component_library: {
        raw: {}
      },
      backwards_compat: {
        raw: {}
      },
      availability: {
        raw: {}
      },
      see_also: {
        raw: {}
      }
    }
  },
  autocompleteQuery: {
    results: {
      resultsPerPage: 5,
      result_fields: {
        name: {
          raw: {}
        }
      }
    },
    suggestions: {
      types: {
        documents: {
          fields: ['name', 'see_also'] // fields whose values can be used as query suggestions
        }
      },
      size: 5
    }
  }
};